module.exports = __webpack_public_path__ + "static/media/placeholderImg.f87282c0.svg";